import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from '@/api';
import {
    DistrictDocument,
    PaginatedResponse
} from '@/interfaces';

@Injectable({
    providedIn: 'root'
})
export class DistrictDocumentsService {

    constructor(private apiService: ApiService) {
    }

    listing(params: Record<string, any>): Observable<PaginatedResponse<DistrictDocument>> {
        return this.apiService.get<any>('/district-documents', this.apiService.build(params)).pipe(
            map((res: any) => ({
                data: res.data,
                total: res.total,
                current_page: res.current_page,
                per_page: res.per_page
            }))
        );
    }

    export(params: Record<string, any>): Observable<Blob> {
        return this.apiService.postBlob('/district-documents/export', params);
    }
}
